import React from 'react';
import { Layout } from 'fronton-react';
import {
  Banner,
  HeaderSection,
  RootLayout,
  StepsSection,
  UtpCardSection,
} from 'common/components';
import { useScrollToElement } from 'common/hooks';
import { SpecialOffer } from 'remotes/special-offer';
import {
  CONSTRUCTION_HOUSES_CARDS_BANNER,
  CONSTRUCTION_HOUSES_CDN_PATH,
  CONSTRUCTION_HOUSES_ELEMENT_BLOCK,
  CONSTRUCTION_HOUSES_PARTNER_BANNER,
  CONSTRUCTION_HOUSES_PATH,
  CONSTRUCTION_HOUSES_STEPS_LIST,
} from './construction-houses-constants';
import {
  CONSTRUCTION_HOUSES_UTP_CARD_LIST,
  ConstructionHousesAdviceSection,
  ConstructionHousesBenefits,
  ConstructionHousesGallerySection,
  ConstructionHousesProjectsSection,
} from './components';

export const ConstructionHouses = () => {
  const { elRef, onScrollToElement } = useScrollToElement(120, 'start');

  return (
    <RootLayout currentPage={CONSTRUCTION_HOUSES_PATH}>
      <HeaderSection
        bgColor="#FDC300"
        description="Строите дом для себя или профессионально? Мы&nbsp;поможем на&nbsp;каждом этапе проекта, независимо от&nbsp;его масштаба."
        img={{
          ldSrcSet: `${CONSTRUCTION_HOUSES_CDN_PATH}/header/header-ld.jpg/header-ld.jpg`,
          dSrcSet: `${CONSTRUCTION_HOUSES_CDN_PATH}/header/header-d.jpg/header-d.jpg`,
          tSrcSet: `${CONSTRUCTION_HOUSES_CDN_PATH}/header/header-t.jpg/header-t.jpg`,
          mSrcSet: `${CONSTRUCTION_HOUSES_CDN_PATH}/header/header-m.jpg/header-m.jpg`,
          title: 'Постройте дом с Лемана ПРО',
          alt: 'Дом, построенный с Лемана ПРО',
        }}
        mediaType="image"
        title="Постройте дом с&nbsp;Лемана&nbsp;ПРО"
        textColor="text-primary"
        buttonTitle="Смотреть проекты"
        elementBlock={CONSTRUCTION_HOUSES_ELEMENT_BLOCK}
        elementText="Постройте дом с Лемана ПРО"
        handleHeaderButtonClick={onScrollToElement}
      />
      <Layout>
        <ConstructionHousesBenefits />
        <UtpCardSection
          elementBlock={CONSTRUCTION_HOUSES_ELEMENT_BLOCK}
          elementText="Постройте дом с Лемана ПРО"
          renderModalContent={({ modal: { content: ModalContent } = {} }) => ModalContent && <ModalContent />}
          utpCardList={CONSTRUCTION_HOUSES_UTP_CARD_LIST}
        />
        <Banner {...CONSTRUCTION_HOUSES_PARTNER_BANNER} />
        <SpecialOffer elementBlock={CONSTRUCTION_HOUSES_ELEMENT_BLOCK} />
        <ConstructionHousesProjectsSection
          sectionRef={(el: HTMLElement | null) => {
            elRef.current = el;
          }}
        />
        <Banner {...CONSTRUCTION_HOUSES_CARDS_BANNER} />
        <ConstructionHousesGallerySection />
        <StepsSection sectionTitle="Как заказать проект " steps={CONSTRUCTION_HOUSES_STEPS_LIST} />
        <ConstructionHousesAdviceSection />
      </Layout>
    </RootLayout>
  );
};
